module.exports = __webpack_public_path__ + "static/media/payment.01ddc00b.gif";